/** Rota interna para detalhe de solicitação na fila financeira. */
export function financeRequestDetailPath(requestId: string): string {
  return `/financeiro/fila/${requestId}`
}
